import { render, staticRenderFns } from "./NoCar.vue?vue&type=template&id=31a210a2&scoped=true&"
import script from "./NoCar.vue?vue&type=script&lang=js&"
export * from "./NoCar.vue?vue&type=script&lang=js&"
import style0 from "./NoCar.vue?vue&type=style&index=0&id=31a210a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a210a2",
  null
  
)

export default component.exports